import React, { Component } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
} from "@material-ui/core";
import { Card } from "react-bootstrap";
import AdministrationDescription from "./AdministrationDescription";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

const list = [
  {
    title: "From the Desk of President",
    link: "/administrations/president",
    gr: 'president'
  },
  {
    title: "From the Desk of Principal",
    link: "/administrations/principal",
    gr: 'principal'
  },
  {
    title: "Governing Body",
    link: "/administrations/gb",
    gr: 'gb'
  },
  {
    title: "Office Staff",
    link: "/administrations/officestaff",
    gr: 'officestaff'
  }
];

class AdministrationContainer extends Component {
  state = {
    link: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    return (
      <div>
        
        {/* <Container className="mb-4">
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{ paddingTop: "2em" }}
            >
              <Card
                style={{
                  boxShadow: "none",
                  position: "stickey !important",
                  top: "0 !important",
                  // backgroundColor: '#EBDB86',
                  // border: `solid 2px #808080`
                }}
              >
                <div
                  style={{
                    boxShadow: "none",
                    position: "stickey",
                    top: "0",
                  }}
                >
                  <List component="nav">
                    {list.map((el, index) => (
                      <ListItem
                        button
                        style={{
                          border: "1px solid #0002",
                        marginBottom: "2px",
                        backgroundColor: el.link === `/administrations/${this.state.link}` ? '#F5EB3D' :'#f9f9f9'
                        }}
                        key={index}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <div
                          style={{
                            fontSize: "1.2em",
                            fontWeight: "700",
                            padding: "0",
                          }}
                        >
                          {el.title}
                        </div>
                      </ListItem>
                    ))}
                  </List>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9} style={{minHeight: '800px'}}>
              
            </Grid>
          </Grid>
        </Container> */}

        <AdministrationDescription type={this.state.link} />
      </div>
    );
  }
}

export default AdministrationContainer;
